import endpoint from "../../config/endpoints";

export const holidayStructureJson = {
    showSaveNextBtn: true,
    formPath: "/holiday-structure-form",
    apiBaseURL: endpoint.holidayStructureHeader,
    changeExcel: endpoint.exportData,
    screenTitle: "Holiday Structure",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday Structure",
    showExcelDownload: true,
    excelFileName: "Holiday Structure",
    formPathView: "/holiday-structure-view",
    isActiveURL: endpoint.holidayStructureHeader + "/update-is-active",

    tableColumnsToFilter: [
        {
            columnDisplayName: "Structure Name",
            columnKeyName: "structureName",
            isChecked: true,
        },
        {
            columnDisplayName: "From Date",
            columnKeyName: "fromDate",
            isChecked: true,
        },
        {
            columnDisplayName: "To Date",
            columnKeyName: "toDate",
            isChecked: true,
        },
        {
            columnDisplayName: "Optional Leave Limit",
            columnKeyName: "optionalLeaveLimit",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Count",
            columnKeyName: "salesTeamCount",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Structure Name",
            controlType: "textfield",
            placeHolder: "Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "name",
            inputType: "numberText",
            isMandatory: true,
            uniqueValidation: true,
        },
        {
            label: "Optional Leave Limit",
            controlType: "textfield",
            placeHolder: "Optional Leave Limit",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "optionalLimit",
            inputType: "number",
            isMandatory: true,
        },
        {
            label: "Holiday Year",
            controlType: "autocomplete",
            placeHolder: "Select Holiday Year",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "holidayYearMasterDetail",
            dataKey: "holidayYearMaster",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};
